import React, { Component } from 'react';
import { connect } from 'react-redux';
import { notify } from 'reducers/NotifierReducer';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {    
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {    
    this.setState({ error, errorInfo });
    localStorage.setItem('showErrorToast', 'true');    
    window.location.reload();
  }

  componentDidMount() {
    if (localStorage.getItem('showErrorToast') === 'true') {
      localStorage.removeItem('showErrorToast'); // Reset flag
      this.props.notify('Something went wrong. If the issue persists, contact support.', 'error');
    }
  }

  render() {
    if (this.state.hasError) {      
      return null;
    }    
    return this.props.children;
  }
}

export default connect(null, {
    notify,
})(ErrorBoundary);